import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";

const links = [
  ["How It Works", "/how-it-works"],
  ["How Receipts Work", "/how-receipts-work"],
  ["Resolution Rules", "/resolution-rules"],
  ["Community", "/guidelines"],
  ["Contact", "/contact"],
  ["Terms", "/terms"],
  ["Privacy", "/privacy"],
];

export default function Footer() {
  return (
    <footer className="border-t-2 border-ink mt-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 py-10">
        <div className="font-display text-2xl font-bold tracking-tight">{BRAND.name}</div>
        <p className="text-sm text-muted-foreground mb-6">{BRAND.tagline}</p>
        <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm font-medium">
          {links.map(([label, to]) => (
            <Link key={to} to={to} data-testid={`footer-link-${to.slice(1)}`} className="hover:text-brand underline-offset-4 hover:underline">
              {label}
            </Link>
          ))}
        </div>
        <p className="text-xs text-muted-foreground mt-6 max-w-lg">
          {BRAND.name} records predictions and when they were made. It does not guarantee outcomes and is
          not a gambling or betting service. Guest names are not verified identities.
        </p>
      </div>
    </footer>
  );
}
